/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import defaultImage from "../images/default.jpg"

const Seo = ({ description, title, children, eyecatch, language }) => {
  if (language === undefined || language === null) {
    language = 'ja'
  }
  
  const { site, allDataYaml } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
        allDataYaml {
          edges {
            node {
              caption {
                common {
                  ja {
                    site_title
                    description
                  }
                  en {
                    site_title
                    description

                  }
                }
              }
            }
          }
        }
      }
    `
  )

  let metaDescription = description || allDataYaml.edges[0].node.caption.common.ja.description
  let defaultTitle = allDataYaml.edges[0].node.caption.common.ja.site_title

  if (language === 'en') {
    metaDescription = allDataYaml.edges[0].node.caption.common.en.description
    defaultTitle = allDataYaml.edges[0].node.caption.common.en.site_title
  }

  const fixedTitle = title ? (`${title} | ${defaultTitle}`) : defaultTitle
  const metaTitle = title ? title : defaultTitle
  const siteUrl = site.siteMetadata.siteUrl
  const eyecatchImage = eyecatch ? (siteUrl + eyecatch) : (siteUrl + defaultImage)

  return (
    <html lang={language}>
      <head>
        <title>{fixedTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={eyecatchImage} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:domain" content={siteUrl} />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={eyecatchImage} />
        <meta property="og:locale:alternate" content={language} />
      </head>
      {children}
    </html>
  )
}

export default Seo
